"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComparisonColor = exports.useVisualizationsTheme = exports.VisualizationsThemeProvider = exports.VisualizationsThemeContext = void 0;
var React = __importStar(require("react"));
var theme_1 = require("./theme");
exports.VisualizationsThemeContext = React.createContext((0, theme_1.createVisualizationsTheme)());
var VisualizationsThemeProvider = function (_a) {
    var localTheme = _a.localTheme, children = _a.children;
    return (React.createElement(exports.VisualizationsThemeContext.Provider, { value: localTheme || (0, theme_1.createVisualizationsTheme)() }, children));
};
exports.VisualizationsThemeProvider = VisualizationsThemeProvider;
var useVisualizationsTheme = function () {
    return React.useContext(exports.VisualizationsThemeContext);
};
exports.useVisualizationsTheme = useVisualizationsTheme;
var useComparisonColor = function () {
    var comparisonColors = (0, exports.useVisualizationsTheme)().comparisonColors;
    var defaultIndex = 0;
    return function (color) {
        if (color === void 0) { color = defaultIndex; }
        if (typeof color === "number")
            return (comparisonColors[color % comparisonColors.length] ||
                comparisonColors[defaultIndex] // Fallback for invalid numbers (negative or decimal)
            );
        return color || comparisonColors[defaultIndex];
    };
};
exports.useComparisonColor = useComparisonColor;
//# sourceMappingURL=ThemeContext.js.map